<template>
  <section
    id="exchange-voucher-content"
    class="invoice-preview-wrapper"
    style="position: relative"
  >
    <!-- Alerte : Aucun bon d'échange trouvé -->
    <b-alert
      variant="danger"
      :show="exchangeVoucher === undefined"
      aria-live="assertive"
      aria-atomic="true"
    >
      <h4 class="alert-heading">
        Erreur lors de la récupération du bon d'échange
      </h4>
      <div class="alert-body">
        Aucun bon d'échange trouvé avec cet identifiant. Consultez
        <b-link
          class="alert-link"
          :to="{ name: 'bon-echange-list' }"
        >
          la liste des bons d'échange
        </b-link>
        pour d'autres bons.
      </div>
    </b-alert>

    <b-row
      v-if="exchangeVoucher"
      class="invoice-preview"
    >
      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          v-if="exchangeVoucher"
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <div
            class="d-flex justify-content-center flex-md-row flex-column invoice-spacing mt-0"
          >
            <div style="color: black">
              <div class="logo-wrapper">
                <img
                  src="/logo.png"
                  class="exchange-voucher-logo"
                  width="150px"
                  height="auto"
                >
                <h3 class="text-primary invoice-logo" />
              </div>
            </div>
          </div>

          <b-card-body class="d-flex flex-row justify-content-between">
            <div style="color: black">
              <div class="ml-1">
                <h1
                  style="color: black; font-size: 30px"
                  aria-label="En-tête du bon d'échange"
                >
                  Bon d'échange
                </h1>
              </div>
              <div>
                <h3
                  class="ml-1"
                  style="color: black"
                >
                  Date :
                  <span style="color: black"> {{ formatFn(exchangeVoucher.created_at) }}</span>
                </h3>
              </div>
              <div>
                <h3
                  class="ml-1"
                  style="color: black"
                >
                  Nombre de colis échangés :
                  <span style="color: black"> {{ exchangeVoucher.orders.length }}</span>
                </h3>
              </div>
            </div>
            <div
              class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0 mr-1"
            >
              <div
                class="mb-2 mt-0 ml-2"
                style="border: 2px solid black"
              >
                <b-card-text
                  class="ml-2 mr-2 mt-2 mb-1 h3"
                  style="color: black"
                >
                  <strong>{{ company.name }} :</strong> {{ company.tagline || 'Société de logistique et livraison à domicile' }}
                </b-card-text>
                <b-card-text
                  class="ml-2 h3 mr-2 mb-1"
                  style="color: black"
                >
                  <strong>Matricule fiscale :</strong> {{ company.tax_identification_number }}
                </b-card-text>
                <b-card-text
                  class="ml-2 mr-2 mb-1 h3"
                  style="color: black"
                >
                  <strong>Adresse : </strong>{{ company.address }}
                </b-card-text>
                <b-card-text
                  class="ml-2 mr-2 mb-1 h3"
                  style="color:black"
                >
                  <strong>Téléphone :</strong> {{ company.phone1 }}
                </b-card-text>
              </div>
            </div>

          </b-card-body>

          <!-- Invoice Description: Table -->
          <b-card-body class="invoice-padding pt-0">
            <b-table-lite
              class="ta"
              responsive
              :items="orders"
              :fields="[
                'code',
                'expéditeur',
                'gouvernorat',
                'tel',
                'destinataire',
                'adresse',
                'prix',
              ]"
            >
              <!--  <template
                #cell(code)="data"
              >
                <qrcode-vue
                  :value="data.item.code.toString()"
                  :size="size"
                  level="H"
                />
                <span>{{ data.item.code.toString() }}</span>
              </template> -->
              <template
                #cell(code)="data"
              >
                <span aria-label="Identifiant du colis échangé">
                  {{ data.item.code.toString() }}
                </span>
                <h4
                  v-if="data.item.is_an_exchange"
                  style="color:red ; font-weight: bold; text-align:center;"
                  aria-label="Colis en échange"
                > Échange </h4>
              </template>
              <template #cell(taskDescription)="data">
                <b-card-text class="font-weight-bold mb-25">
                  {{ data.item.taskTitle }}{{ data.item.taskTitle }}
                </b-card-text>
                <b-card-text class="text-nowrap">
                  {{ data.item.taskDescription }}
                </b-card-text>
              </template>
            </b-table-lite>
          </b-card-body>
          <!-- Invoice Description: Total -->

          <b-card-body class="d-flex justify-content-between mt-5">
            <!-- Col: Total -->

            <div class="mb-5 ml-1">
              <h3 style="color: black; font-size: 25px">
                Signature
              </h3>
            </div>
          </b-card-body>

        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>
          <!-- Button: Print -->
          <b-button
            v-if="!isLoading"
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            <b-icon
              icon="printer"
              class="mr-1"
            />
            Imprimer
          </b-button>

          <!-- Button: Edit -->
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import axios from 'axios'
import storeAuth from '@/store/store'
// import QrcodeVue from 'qrcode.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    // QrcodeVue,
  },
  data() {
    return {
      exchangeVoucher: {},
      orders: [],
      isLoading: false,
    }
  },

  created() {
    this.id = this.$route.params.id
    this.getExchangeVoucher()
    this.company = storeAuth.state.company
  },
  methods: {
    formatFn(date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      const day1 = day.substr(0, 2)
      const h = date.slice(11, 19)
      return `${year}-${month.padStart(2, '0')}-${day1.padStart(2, '0')} | ${h}`
    },

    async getExchangeVoucher() {
      this.isLoading = true
      const response = await axios.get(`/api/exchange-vouchers/detail/${this.$route.params.id}`)
      this.exchangeVoucher = response.data
      const { orders } = this.exchangeVoucher
      for (let i = 0; i < orders.length; i += 1) {
        const data = {
          code: orders[i].id,
          gouvernorat: orders[i].governorate,
          expéditeur: orders[i].supplier.username,
          tel: orders[i].phone1,
          destinataire: orders[i].name,
          adresse: orders[i].address,
          prix: orders[i].price_ttc,
          is_an_exchange: orders[i].is_an_exchange,
        }
        this.orders.push(data)
        this.isLoading = false
      }
    },
  },
  setup() {
    const total = 0
    const printInvoice = () => {
      window.print()
    }

    return {
      printInvoice,
      total,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
table,
td,
th {
  padding: 10px;
  text-align: left;
  border: 1px solid black;
}
footer {
  bottom: 0;
  height: auto; /* Footer height */
}
table {
  width: 100%;
  border-collapse: collapse;
}
.mycolor {
  background-color: #EA2F2F;
}
.contact {
  background-color: #EA2F2F;
  padding: 10px;
  border-radius: 20px;
}
.exchange-voucher-logo {
  width: 150px;
  max-height: 75px;
  object-fit: contain;
}
</style>

<style lang="scss">
@page {
  margin: 0;
}

body {
  margin: 0;
}

@media print {
  html, body {
    margin: 0;
    padding: 0;
    height: 99%;
  }
  #exchange-voucher-content {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
  }
  #app,
  .app-content,
  .app-content .content-wrapper,
  .app-content .content-body,
  .content-header,
  .content-area-wrapper {
    margin: 0 !important;
    padding: 0 !important;
  }
  .content.app-content {
    margin-left: 0;
    padding: 0 !important;
  }
  .ta {
    overflow: visible;
    font-size: 18px;
    color: black;
  }
  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: auto; /* Footer height */
  }

  .table thead th {
    border: 2px solid black;
  }

  .exchange-voucher-logo {
    width: 120px !important;
    max-height: 65px !important;
    height: auto !important;
    object-fit: contain;
  }

  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding: 0 !important;
  }
  .mycolor {
    background-color: #EA2F2F;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  .contact {
    background-color: #EA2F2F;
    padding: 20px;
    border-radius: 25px;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  footer footer-light footer-static {
    display: inline-block;
  }
  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    .row.invoice-preview {
      margin: 0 !important;
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        margin: 0 !important;
        padding: 0 !important;
        .card-body:nth-of-type(2) {
          .row {
            > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
  table,
  td,
  th {
    padding: 10px;
    text-align: left;
    border: 1px solid black;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  .invoice-preview-wrapper .card,
  .invoice-preview-wrapper .card-body,
  .invoice-preview-wrapper [class*='col-'] {
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
